export default {
  // Theme getter
  isDark: state => state.isDark,
}
